import React from 'react';
import { useState } from "react";
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Grid,
    Typography,
    Box,
    TextField,
    TablePagination,
    // Button,
    TableFooter,
    Tooltip
} from "@mui/material";
import Select, { components } from 'react-select';
import Loader from 'utils/Loader';
import { DateRange } from "react-date-range";
import { ClickAwayListener } from "@mui/material";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import PendingOrderReportsController from 'pages/Controller/PendingOrderReportsController';
import { IconButton } from '../../../node_modules/@mui/material/index';
import { Clear } from '../../../node_modules/@mui/icons-material/index';
import ZoomWrapper from 'utils/ZoomWrapper';
import FileDownloadIcon from "@mui/icons-material/FileDownload";
   

const addSelectAllOption = (options) => [
    { label: "Select All", value: "__ALL__", isSelectAll: true },
    ...options
];

/* ================= CHECKBOX OPTION (REUSABLE) ================= */
const CheckboxOption = (props) => {
    const { label, amount, isSelectAll } = props.data;
    const { isSelected, selectOption, getValue } = props;

    // 🔥 FORCE Select-All checked state
    const allSelected =
        isSelectAll &&
        getValue().length > 0 &&
        getValue().length === props.options.filter(o => !o.isSelectAll).length;

    const checked = isSelectAll ? allSelected : isSelected;

    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        selectOption(props.data);
    };

    return (
        <button
            type="button"
            onMouseDown={handleClick}
            style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "6px 10px",
                cursor: "pointer",
                background: isSelectAll ? "#f5f5f5" : "#fff",
                color: "#000",
                border: "none",
                width: "100%",
                textAlign: "left",
                fontSize: "13px"
            }}
        >
            <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
                <input
                    type="checkbox"
                    checked={checked}
                    readOnly
                    style={{ width: 14, height: 14 }}
                />
                <span style={{ color: "#000", fontWeight: 400 }}>{label}</span>
            </div>

            {amount && (
                <span style={{ fontSize: "12px", color: "#b1005a", fontWeight: 600 }}>
                    {amount}
                </span>
            )}
        </button>
    );
};


const PendingOrderReports = () => {
    const {
        pendingOrders,
        topCustomers,
        topQualities,
        cloading,
        page,
        totalRecords,
        handleChangePage,

        filters,
        handleFilterChange,
        handleDateFromChange,
        handleDateToChange,

        zoneOptions,
        statusOptions,
        customerNameOptions,
        descriptionOptions,
        lastUpdatedDate,
        lastUpdatedTime,
        divisionlist,
        handleCustomerSearch,
        isFromApp
    } = PendingOrderReportsController();

    //const today = new Date().toISOString().split("T")[0];
    // const [showCalendar, setShowCalendar] = useState(false);

    const [range, setRange] = useState([
        {
            startDate: filters.fromDate ? new Date(filters.fromDate) : null,
            endDate: filters.toDate ? new Date(filters.toDate) : null,
            key: "selection",
        },
    ]);

    const clearDateRange = () => {
        setRange([
            {
                startDate: null,
                endDate: null,
                key: "selection",
            },
        ]);

        handleDateFromChange("");
        handleDateToChange("");
    };


    const [showCalendar, setShowCalendar] = useState(false);

    // ---------- GRAND TOTALS ----------
    const totalQualityRemMtr = topQualities.reduce(
        (sum, q) => sum + Number(q.pending_mtr || 0),
        0
    );

    const totalQualityRSOQty = topQualities.reduce(
        (sum, q) => sum + Number(q.total_rso_qty || 0),
        0
    );

    const totalCustomerRemMtr = topCustomers.reduce(
        (sum, c) => sum + Number(c.total_rem_qty_mtr || 0),
        0
    );

    const totalCustomerRSOQty = topCustomers.reduce(
        (sum, c) => sum + Number(c.total_rso_qty || 0),
        0
    );

    const NoMultiValue = () => null;

    const singleLineSelectStyles = {
        menuPortal: (b) => ({ ...b, zIndex: 9999 }),
        control: (base) => ({
            ...base,
            minHeight: 38,
            height: 38
        }),
        valueContainer: (base) => ({
            ...base,
            height: 38,
            padding: "0 8px",
            overflow: "hidden"
        }),
        placeholder: (base) => ({
            ...base,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
            color: "#000",
            fontWeight: 500
        }),
        indicatorsContainer: (base) => ({
            ...base,
            height: 38
        })
    };

    const [isZoneOpen, setIsZoneOpen] = useState(false);
    const [isCustomerOpen, setIsCustomerOpen] = useState(false);
    const [zoneSearchText, setZoneSearchText] = useState("");
    const [customerSearchText, setCustomerSearchText] = useState("");


    const makeClearTextOnlyIndicator = (setText) =>
        function ClearTextOnlyIndicator(props) {
            return (
                <components.ClearIndicator
                    {...props}
                    innerProps={{
                        ...props.innerProps,
                        onMouseDown: (e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setText("");        // ✅ clear only typed text
                        }
                    }}
                />
            );
        };

    const ZoneClearIndicator = makeClearTextOnlyIndicator(setZoneSearchText);
    const CustomerClearIndicator = makeClearTextOnlyIndicator(setCustomerSearchText);

    //zone dropdown-
    const excludedZones = zoneOptions.filter(
        (z) => !filters.zone.some((s) => s.value === z.value)
    );
    const selectedZoneCount = filters.zone.length;
    const zonePlaceholder = isZoneOpen
        // ? `ZONE${excludedZones.length ? ` Excluded (${excludedZones.length})` : ""}`
        ? `ZONE${selectedZoneCount ? ` selected (${selectedZoneCount})` : ""}`
        : excludedZones.length
            ? `ZONE: Excluded: ${excludedZones.map(z => z.label).join(", ").slice(0, 45)
            }${excludedZones.map(z => z.label).join(", ").length > 45 ? "..." : ""}`
            : "ZONE";

    const zoneTooltip =
        excludedZones.length ? `Excluded:\n${excludedZones.map(z => z.label).join("\n")}` : "";

    //customer dropdown-
    const excludedCustomers = customerNameOptions.filter(
        (c) => !filters.customerName.some((s) => s.value === c.value)
    );
    const selectedCustomerCount = filters.customerName.length;
    const customerPlaceholder = isCustomerOpen
        //? `CUSTOMER_NAME${excludedCustomers.length ? ` Excluded (${excludedCustomers.length})` : ""}`
        ? `CUSTOMER_NAME${selectedCustomerCount ? ` selected (${selectedCustomerCount})` : ""}`
        : excludedCustomers.length
            ? `CUSTOMER_NAME: Excluded: ${excludedCustomers.map(c => c.label).join(", ").slice(0, 45)
            }${excludedCustomers.map(c => c.label).join(", ").length > 45 ? "..." : ""}`
            : "CUSTOMER_NAME";

    const customerTooltip =
        excludedCustomers.length ? `Excluded:\n${excludedCustomers.map(c => c.label).join("\n")}` : "";

    /* ================= SELECT ALL HANDLERS ================= */

    // ZONE
    const handleZoneChange = (selected) => {
        if (!selected) {
            handleFilterChange("zone")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.zone.length === zoneOptions.length;

            handleFilterChange("zone")(
                allSelected ? [] : zoneOptions
            );
            return;
        }

        handleFilterChange("zone")(selected);
    };



    // CUSTOMER / GROUP PARTY
    const handleCustomerChange = (selected) => {
        if (!selected) {
            handleFilterChange("customerName")([]);
            return;
        }

        if (selected.some(o => o.value === "__ALL__")) {
            const allSelected =
                filters.customerName.length === customerNameOptions.length;

            handleFilterChange("customerName")(
                allSelected ? [] : customerNameOptions
            );
            return;
        }

        handleFilterChange("customerName")(selected);
    };

    /* ================= GRAND TOTALS (MAIN TABLE) ================= */

    const totals = pendingOrders.reduce(
        (acc, row) => {
            acc.SOQty += Number(row.SOQty || 0);
            acc.DeliveryQty += Number(row.DeliveryQty || 0);
            acc.RSOQty += Number(row.RSOQty || 0);
            acc.SOQtyMtr += Number(row.SOQtyMtr || 0);
            acc.RemQtyMtr += Number(row.RemQtyMtr || 0);
            return acc;
        },
        {
            SOQty: 0,
            DeliveryQty: 0,
            RSOQty: 0,
            SOQtyMtr: 0,
            RemQtyMtr: 0
        }
    );

    const mainTableHeaders = [
        "DATE",
        "PLANT",
        "SUBDIVISION",
        "SO No",
        "ITEM No",
        "ZONE",
        "PARTY CODE",
        "CUSTOMER_NAME",
        "DESCRIPTION",
        "SIZE",
        "STATUS",
        "REMARKS",
        "ORDER REASON DESCRIPTION",
        "RETAILER NAME",
        "MATERIAL",
        "SO QTY",
        "DELV QTY",
        "RSOQTY",
        "SO QTY MTR",
        "REM QTY MTR"
    ];

    const toCsvValue = (value) => {
        const safe = String(value ?? "").replace(/"/g, '""');
        return `"${safe}"`;
    };

    const handleExportMainTableCsv = () => {
        const rows = pendingOrders.map((r) => ([
            r.date,
            r.plant,
            r.division,
            r.SONumber,
            r.itemNo,
            r.zoneName,
            r.customer,
            r.custName,
            r.description,
            r.size,
            r.status,
            r.remark || "-",
            r.orderReasonDesc || "-",
            r.retailerName || "-",
            r.material,
            r.SOQty,
            r.DeliveryQty,
            r.RSOQty,
            r.SOQtyMtr,
            r.RemQtyMtr
        ]));

        if (rows.length) {
            rows.push([
                "", "", "", "", "", "", "", "", "", "", "", "", "", "",
                "GRAND TOTAL",
                totals.SOQty,
                totals.DeliveryQty,
                totals.RSOQty,
                totals.SOQtyMtr,
                totals.RemQtyMtr
            ]);
        }

        const csv = [
            mainTableHeaders.map(toCsvValue).join(","),
            ...rows.map((row) => row.map(toCsvValue).join(","))
        ].join("\n");

        const blob = new Blob(["\uFEFF" + csv], {
            type: "text/csv;charset=utf-8;"
        });
        const link = document.createElement("a");
        const url = URL.createObjectURL(blob);
        link.href = url;
        link.setAttribute(
            "download",
            `pending_order_reports_${new Date().toISOString().slice(0, 10)}.csv`
        );
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
    };



    return (
        <>
            {cloading && (
                <div
                    className="overlay"
                    style={{
                        position: "fixed",
                        inset: 0,
                        width: "100vw",
                        height: "100vh",
                        zIndex: 14000,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexDirection: "column"
                    }}
                >
                    <Loader />
                    <span style={{ marginTop: "8px" }}>Data loading...</span>
                </div>
            )}
            <ZoomWrapper>
                <div className={isFromApp ? "" : "bg" } style={{ display: 'block', zoom: "90%", position: 'relative' }}>

                    {!isFromApp && (
  <div style={{ textAlign: "center" }}>
    <span className="font20">Pending Order Reports</span>
  </div>
)}

{!isFromApp && ( <div className="orderrow"></div> )}

                    {/* -------------------- INFO HEADER BOX -------------------- */}
                    <Paper elevation={2} sx={{ p: 2, mb: 3 }}>
                        <Typography
                            variant="body1"
                            sx={{
                                // fontWeight: '500',
                                textAlign: 'center',
                                color: '#444444'

                            }}
                        >
                            DIVISION WISE PENDING ORDER DASHBOARD  {divisionlist
                                ? divisionlist
                                    .split(",")
                                    .map(d => d.trim().toUpperCase())
                                    .join(", ")
                                : "--"}
                            {" "}
                            UPDATED AS ON : {lastUpdatedDate || "--"}
                            {/* &nbsp; TIME : {lastUpdatedTime || "--"} */}
                        </Typography>
                    </Paper>
                    <Grid container spacing={2} sx={{ mb: 3 }}>

                        {/* ================= FILTERS (TOP) ================= */}

                        <Grid item xs={12} md={2} sx={{ position: "relative" }}>
                            <TextField
                                placeholder="DATE RANGE"
                                value={
                                    range[0].startDate && range[0].endDate
                                        ? `${range[0].startDate.toLocaleDateString("en-GB")} - ${range[0].endDate.toLocaleDateString("en-GB")}`
                                        : ""
                                }
                                onClick={() => setShowCalendar(!showCalendar)}
                                readOnly
                                InputProps={{
                                    readOnly: true,
                                    endAdornment: range[0].startDate && (
                                        <IconButton
                                            size="small"
                                            onClick={(e) => {
                                                e.stopPropagation(); // calendar open hone se roke
                                                clearDateRange();
                                            }}
                                        >
                                            <Clear fontSize="small" sx={{ color: "#666" }} />
                                        </IconButton>
                                    ),
                                }}
                                fullWidth
                                sx={{
                                    backgroundColor: "#fff",
                                    borderRadius: "6px",
                                    cursor: "pointer",
                                }}
                            />

                            {showCalendar && (
                                <ClickAwayListener onClickAway={() => setShowCalendar(false)}>
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: "100%",
                                            left: 0,
                                            zIndex: 9999,
                                            boxShadow: 3,
                                            mt: 1,
                                            backgroundColor: "#fff",
                                        }}
                                    >
                                        <DateRange
                                            editableDateInputs
                                            moveRangeOnFirstSelection={false}
                                            ranges={range}
                                            maxDate={new Date()}
                                            onChange={(item) => {
                                                setRange([item.selection]);

                                                const start = item.selection.startDate.toLocaleDateString("en-CA");
                                                const end = item.selection.endDate.toLocaleDateString("en-CA");

                                                handleDateFromChange(start);
                                                handleDateToChange(end);

                                                setShowCalendar(false);
                                            }}
                                        />
                                    </Box>
                                </ClickAwayListener>
                            )}
                        </Grid>
                        {/* ZONE (WITH AMOUNT) */}
                        <Grid item xs={12} md={2}>
                            <div title={zoneTooltip}>
                                {/* <Select
                                    // options={zoneOptions}
                                    // value={filters.zone}
                                    // onChange={handleFilterChange("zone")}
                                    options={addSelectAllOption(zoneOptions)}
                                    value={filters.zone}
                                    onChange={handleZoneChange}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}
                                    components={{ Option: CheckboxOption, MultiValue: NoMultiValue }}
                                    placeholder={zonePlaceholder}
                                    onMenuOpen={() => setIsZoneOpen(true)}
                                    onMenuClose={() => setIsZoneOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
                                <Select
                                    options={addSelectAllOption(zoneOptions)}
                                    value={filters.zone}
                                    onChange={handleZoneChange}

                                    inputValue={zoneSearchText}
                                    onInputChange={(val, { action }) => {
                                        if (action === "input-change") {
                                            setZoneSearchText(val);
                                        }
                                        if (action === "set-value") {
                                            return zoneSearchText;   // preserve typed text
                                        }
                                        return val;
                                    }}

                                    isMulti
                                    isClearable={Boolean(zoneSearchText)}     // ✅ show ❌ only when typing
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}

                                    components={{
                                        Option: CheckboxOption,
                                        MultiValue: NoMultiValue,
                                        ClearIndicator: ZoneClearIndicator
                                    }}

                                    placeholder={zonePlaceholder}
                                    onMenuOpen={() => setIsZoneOpen(true)}
                                    onMenuClose={() => setIsZoneOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                />


                            </div>
                        </Grid>
                        <Grid item xs={12} md={2}>
                            <Select
                                options={statusOptions}
                                value={filters.status}
                                onChange={handleFilterChange('status')}
                                placeholder="STATUS"
                                isClearable
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <div title={customerTooltip}>
                                {/* <Select
                                    options={addSelectAllOption(customerNameOptions)}
                                    value={filters.customerName}
                                    onChange={handleCustomerChange}

                                    onInputChange={(inputValue, { action }) => {
                                        // react-select fires on many actions, we want only typing
                                        if (action !== "input-change") return;

                                        // 🔒 MIN 3 CHAR CHECK HERE
                                        if (inputValue.length >= 3) {
                                            handleCustomerSearch(inputValue);
                                        }
                                    }}
                                    isMulti
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}
                                    components={{ Option: CheckboxOption, MultiValue: NoMultiValue }}
                                    placeholder={customerPlaceholder}
                                    onMenuOpen={() => setIsCustomerOpen(true)}
                                    onMenuClose={() => setIsCustomerOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                /> */}
                                <Select
                                    options={addSelectAllOption(customerNameOptions)}
                                    value={filters.customerName}
                                    onChange={handleCustomerChange}

                                    inputValue={customerSearchText}
                                    onInputChange={(val, { action }) => {
                                        if (action === "input-change") {
                                            setCustomerSearchText(val);
                                        }
                                        if (action === "set-value") {
                                            return customerSearchText;
                                        }
                                        return val;
                                    }}
                                    isMulti
                                    isClearable={Boolean(customerSearchText)}
                                    closeMenuOnSelect={false}
                                    hideSelectedOptions={false}
                                    controlShouldRenderValue={false}

                                    components={{
                                        Option: CheckboxOption,
                                        MultiValue: NoMultiValue,
                                        ClearIndicator: CustomerClearIndicator
                                    }}

                                    placeholder={customerPlaceholder}
                                    onMenuOpen={() => setIsCustomerOpen(true)}
                                    onMenuClose={() => setIsCustomerOpen(false)}
                                    styles={singleLineSelectStyles}
                                    menuPortalTarget={document.body}
                                />

                            </div>
                        </Grid>

                        <Grid item xs={12} md={2}>
                            <Select
                                options={descriptionOptions}
                                value={filters.description}
                                onChange={handleFilterChange('description')}
                                placeholder="DESCRIPTION"
                                isClearable
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Grid>
                    </Grid>

                    {/* -------------------- SUMMARY TABLES -------------------- */}
                    <Grid container spacing={2} sx={{ mb: 3 }}>
                        {/* ================= QUALITY WISE ================= */}
                        <Grid item xs={12} md={5}>
                            <Paper elevation={3}>
                                <TableContainer sx={{ maxHeight: 800 }}>
                                    <Table size="small" >
                                        <TableHead>
                                            <TableRow sx={{ background: "red" }}>
                                                <TableCell colSpan={3} align="center" sx={{ color: "#fff" }}>
                                                    List of Qualities Names with Maximun Pending Meters
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center"><b>DESCRIPTION</b></TableCell>
                                                <TableCell align="center"><b>REM QTY MTR</b></TableCell>
                                                <TableCell align="center"><b>RSOQTY</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {topQualities.map((q, i) => (
                                                <TableRow key={i}>
                                                    <TableCell align="center">{q.description}</TableCell>
                                                    <TableCell align="center">{Number(q.pending_mtr).toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{Number(q.total_rso_qty).toLocaleString("en-IN")}</TableCell>
                                                </TableRow>
                                            ))}
                                            {/* <TableRow sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                                    <TableCell align="center"><b>Grand Total</b></TableCell>
                                    <TableCell align="center">
                                        <b>{totalQualityRemMtr.toLocaleString("en-IN")}</b>
                                    </TableCell>
                                    <TableCell align="center">
                                        <b>{totalQualityRSOQty.toLocaleString("en-IN")}</b>
                                    </TableCell>
                                </TableRow> */}

                                        </TableBody>
                                        <TableFooter>
                                            <TableRow
                                                sx={{
                                                    backgroundColor: "#f5f5f5",
                                                    fontWeight: "bold",
                                                    position: "sticky",
                                                    bottom: 0,
                                                    zIndex: 1,
                                                }}
                                            >
                                                <TableCell align="center"><b>Grand Total</b></TableCell>
                                                <TableCell align="center">
                                                    <b>{totalQualityRemMtr.toLocaleString("en-IN")}</b>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <b>{totalQualityRSOQty.toLocaleString("en-IN")}</b>
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>

                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>

                        {/* ================= CUSTOMER WISE ================= */}
                        <Grid item xs={12} md={7}>
                            <Paper elevation={3}>
                                <TableContainer sx={{ maxHeight: 800 }}>
                                    <Table size="small" >
                                        <TableHead>
                                            <TableRow sx={{ background: "red" }}>
                                                <TableCell colSpan={4} align="center" sx={{ color: "#fff" }}>
                                                    List of Customer Names with Maximun Pending Meters
                                                </TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell align="center"><b>CUSTOMER_NAME</b></TableCell>
                                                <TableCell align="center"><b>ZONE</b></TableCell>
                                                <TableCell align="center"><b>REM QTY MTR</b></TableCell>
                                                <TableCell align="center"><b>RSOQTY</b></TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {topCustomers.map((c, i) => (
                                                <TableRow key={i}>
                                                    <TableCell align="center">{c.custName}</TableCell>
                                                    <TableCell align="center">{c.zoneName}</TableCell>
                                                    <TableCell align="center">{Number(c.total_rem_qty_mtr).toLocaleString("en-IN")}</TableCell>
                                                    <TableCell align="center">{Number(c.total_rso_qty).toLocaleString("en-IN")}</TableCell>
                                                </TableRow>
                                            ))}
                                            {/* <TableRow sx={{ backgroundColor: "#f5f5f5", fontWeight: "bold" }}>
                                    <TableCell align="center" colSpan={2}>
                                        <b>Grand Total</b>
                                    </TableCell>
                                    <TableCell align="center">
                                        <b>{totalCustomerRemMtr.toLocaleString("en-IN")}</b>
                                    </TableCell>
                                    <TableCell align="center">
                                        <b>{totalCustomerRSOQty.toLocaleString("en-IN")}</b>
                                    </TableCell>
                                </TableRow> */}

                                        </TableBody>
                                        <TableFooter>
                                            <TableRow
                                                sx={{
                                                    backgroundColor: "#f5f5f5",
                                                    fontWeight: "bold",
                                                    position: "sticky",
                                                    bottom: 0,
                                                    zIndex: 1,
                                                }}
                                            >
                                                <TableCell align="center" colSpan={2}>
                                                    <b>Grand Total</b>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <b>{totalCustomerRemMtr.toLocaleString("en-IN")}</b>
                                                </TableCell>
                                                <TableCell align="center">
                                                    <b>{totalCustomerRSOQty.toLocaleString("en-IN")}</b>
                                                </TableCell>
                                            </TableRow>
                                        </TableFooter>

                                    </Table>
                                </TableContainer>
                            </Paper>
                        </Grid>
                    </Grid>

                    {/* ================= MAIN REPORT TABLE ================= */}
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "flex-end",
                            alignItems: "center",
                            mb: 1
                        }}
                    >
                        <Tooltip title="Export CSV">
                            <span>
                                <IconButton
                                    size="small"
                                    onClick={handleExportMainTableCsv}
                                    disabled={!pendingOrders.length}
                                    sx={{
                                        color: "#d32f2f",
                                        border: "1px solid #e0e0e0",
                                        borderRadius: 1
                                    }}
                                >
                                    <FileDownloadIcon fontSize="small" />
                                </IconButton>
                            </span>
                        </Tooltip>
                    </Box>
                    <Paper >
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        {mainTableHeaders.map((h) => (
                                            <TableCell key={h} align="center" sx={{ background: "red", color: "#fff" }}>
                                                {h}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {pendingOrders.length ? (
                                        <>
                                            {pendingOrders.map((r, i) => (
                                                <TableRow key={i}>
                                                    <TableCell align="center">{r.date}</TableCell>
                                                    <TableCell align="center">{r.plant}</TableCell>
                                                    <TableCell align="center">{r.division}</TableCell>
                                                    <TableCell align="center">{r.SONumber}</TableCell>
                                                    <TableCell align="center">{r.itemNo}</TableCell>
                                                    <TableCell align="center">{r.zoneName}</TableCell>
                                                    <TableCell align="center">{r.customer}</TableCell>
                                                    <TableCell align="center">{r.custName}</TableCell>
                                                    <TableCell align="center">{r.description}</TableCell>
                                                    <TableCell align="center">{r.size}</TableCell>
                                                    <TableCell align="center">{r.status}</TableCell>
                                                    <TableCell align="center">{r.remark || "-"}</TableCell>
                                                    <TableCell align="center">{r.orderReasonDesc || "-"}</TableCell>
                                                    <TableCell align="center">{r.retailerName || "-"}</TableCell>

                                                    {/* MATERIAL */}
                                                    <TableCell align="center">{r.material}</TableCell>

                                                    {/* TOTAL COLUMNS */}
                                                    <TableCell align="center">{r.SOQty}</TableCell>
                                                    <TableCell align="center">{r.DeliveryQty}</TableCell>
                                                    <TableCell align="center">{r.RSOQty}</TableCell>
                                                    <TableCell align="center">{r.SOQtyMtr}</TableCell>
                                                    <TableCell align="center">{r.RemQtyMtr}</TableCell>
                                                </TableRow>
                                            ))}

                                            {/* ================= GRAND TOTAL ROW ================= */}
                                            <TableRow
                                                sx={{
                                                    backgroundColor: "#f5f5f5",
                                                    "& td": { fontWeight: 700 },
                                                    position: "sticky",
                                                    bottom: 0,
                                                    zIndex: 2
                                                }}
                                            >
                                                {/* EMPTY CELLS UP TO MATERIAL COLUMN */}
                                                {Array.from({ length: 14 }).map((_, i) => (
                                                    <TableCell key={i} />
                                                ))}

                                                {/* MATERIAL COLUMN */}
                                                <TableCell align="center">
                                                    GRAND TOTAL
                                                </TableCell>

                                                {/* TOTALS */}
                                                <TableCell align="center">
                                                    {totals.SOQty.toLocaleString("en-IN")}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {totals.DeliveryQty.toLocaleString("en-IN")}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {totals.RSOQty.toLocaleString("en-IN")}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {totals.SOQtyMtr.toLocaleString("en-IN")}
                                                </TableCell>

                                                <TableCell align="center">
                                                    {totals.RemQtyMtr.toLocaleString("en-IN")}
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    ) : (
                                        <TableRow>
                                            <TableCell colSpan={20} align="center">
                                                No Pending Orders Found
                                            </TableCell>
                                        </TableRow>
                                    )}
                                </TableBody>

                            </Table>
                        </TableContainer>
                    </Paper>
                    <Box
                        sx={{
                            backgroundColor: "#fff",
                            borderTop: "1px solid #ddd",
                            px: 2,
                        }}
                    >
                        <TablePagination
                            component="div"
                            rowsPerPageOptions={[100]}   // fixed page size
                            count={totalRecords}         // TOTAL from API
                            rowsPerPage={100}            // server-side limit
                            page={page - 1}              // convert to 0-based
                            onPageChange={handleChangePage}
                            onRowsPerPageChange={() => { }}
                        />
                    </Box>


                    {/* <Box sx={{ mb: 3 }} /> */}
                </div >
            </ZoomWrapper>
        </>
    );
};

export default PendingOrderReports;
